export var AlertDurationEnum;
(function (AlertDurationEnum) {
    AlertDurationEnum[AlertDurationEnum["s3"] = 3000] = "s3";
    AlertDurationEnum[AlertDurationEnum["s5"] = 5000] = "s5";
    AlertDurationEnum[AlertDurationEnum["s10"] = 10000] = "s10";
    AlertDurationEnum[AlertDurationEnum["s30"] = 30000] = "s30";
    AlertDurationEnum[AlertDurationEnum["s60"] = 60000] = "s60";
    AlertDurationEnum[AlertDurationEnum["NODISMISS"] = -1] = "NODISMISS";
})(AlertDurationEnum || (AlertDurationEnum = {}));
